import {
  faAdd,
  faBracketsCurly,
  faPenToSquare,
} from "@fortawesome/pro-regular-svg-icons";

import { Button } from "src/base-components/Button";
import { EmptyState } from "src/design-system/EmptyState";
import { Tooltip } from "src/design-system/Tooltip";
import { FEATURE_FLAGS, isFeatureFlagEnabled } from "src/router/featureFlags";
import { SchemaOptions } from "src/router/SearchParams";

type Props = {
  type: SchemaOptions;
  handleAddField: () => void;
  isReadonly: boolean;
  onJsonSchemaClick: () => void;
  onManifestNodeBuilderClick?: () => void;
};

const SchemaEmptyStateFlaggedActions: React.FC<{
  isReadonly: boolean;
  onManifestNodeBuilderClick?: () => void;
}> = ({ isReadonly, onManifestNodeBuilderClick }) => {
  const isManifestBuilderEnabled = isFeatureFlagEnabled(
    FEATURE_FLAGS.manifestBuilder,
  );

  if (!isManifestBuilderEnabled || !onManifestNodeBuilderClick) {
    return null;
  }

  return (
    <div className="mt-2 flex flex-col items-center gap-y-2">
      <div className="w-60">
        <Tooltip
          title="Interactive schema builder with live UI preview"
          asChild
        >
          <Button
            dataLoc="manifest-node-builder-empty-button"
            disabled={isReadonly}
            iconLeft={faPenToSquare}
            variant="secondary"
            fullWidth
            onClick={onManifestNodeBuilderClick}
          >
            Manifest Node Builder
          </Button>
        </Tooltip>
      </div>
    </div>
  );
};

export const SchemaEmptyState: React.FC<Props> = (props) => {
  return (
    <>
      <EmptyState
        actionButton={[
          {
            label: "Add field",
            icon: faAdd,
            isDisabled: props.isReadonly,
            onClick: () => props.handleAddField(),
            dataLoc: "add-schema-field",
            tooltip: {
              title:
                "This option is perfect for simple schemas with straightforward field types",
            },
          },
          {
            label: "Generate from JSON schema",
            isDisabled: props.isReadonly,
            onClick: () => props.onJsonSchemaClick(),
            dataLoc: "schema-json-view-empty-button",
            tooltip: {
              title: "Create complex nested schemas from existing JSON schema",
            },
          },
        ]}
        description={`Click below to start creating your ${props.type} schema by adding a field or generate it from JSON.`}
        headline={`Create ${props.type} schema`}
        icon={faBracketsCurly}
      />

      <SchemaEmptyStateFlaggedActions
        isReadonly={props.isReadonly}
        onManifestNodeBuilderClick={props.onManifestNodeBuilderClick}
      />
    </>
  );
};
